/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MessageGroupList = {
    type: 'array',
    contains: {
        type: 'MessageGroup',
    },
};